<template>
  <div class="grid">
    <div
      v-for="(line, idx) in gridLines"
      :key="`line-${idx}`"
      class="grid__line"
      :class="customClass || ''"
      :style="line.style"
    />
    <div
      v-for="(col, idx) in gridColumns"
      :key="`col-${idx}`"
      class="grid__col"
      :class="customClass || ''"
      :style="col.style"
    />
  </div>
</template>

<script>
/**
 * Draw a simple grid on the screen
 * @vue-prop {Number} space           Space between each line of the grid
 * @vue-prop {HTMLElement} container  Element containing the grid
 * @vue-prop {String} customClass     Element containing the grid
 */

import $ from 'jquery';

export default {

  name: 'Grid',

  props: {
    space: {
      type: Number,
      required: true,
    },
    container: {
      type: HTMLElement,
      default: null,
    },
    customClass: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      containerWidth: 0,
      containerHeight: 0,
    };
  },

  computed: {
    /** Array: of objects containing a 'style' property for each line of the grid */
    gridLines() {
      const lines = [];
      let offset = 0;
      while (offset < this.containerHeight) {
        offset += this.space;
        lines.push({ style: { top: `${offset}px` } });
      }
      return lines;
    },
    /** Array: of objects containing a 'style' property for each column of the grid */
    gridColumns() {
      const cols = [];
      let offset = 0;
      while (offset < this.containerWidth) {
        offset += this.space;
        cols.push({ style: { left: `${offset}px` } });
      }
      return cols;
    },
  },

  mounted() {
    const container = this.container || this.$el;
    const rect = container.getBoundingClientRect();
    this.containerWidth = rect.width;
    this.containerHeight = rect.height;

    $(window).on(this.resizeEventName, () => {
      const cont = this.container || this.$el;
      const r = cont.getBoundingClientRect();
      this.containerWidth = r.width;
      this.containerHeight = r.height;
    });
  },
};
</script>

<style lang="scss">
.grid {
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: hidden;

  &__line, &__col {
    background: rgba(0, 0, 0, 0.15);
    position: absolute;
  }
  &__line {
    width: 100%;
    height: 1px;
    left: 0px;
  }
  &__col {
    height: 100%;
    width: 1px;
    top: 0px;
  }
}
</style>
